export default __webpack_public_path__ + "static/media/full-counter.9bd39648.png";